module.exports = __webpack_public_path__ + "assets/img/VentureCrowd-Article-w960.ce48cbc1.jpg";